import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import {
  Modal,
  Input,
  DatePicker,
  Select,
  Button,
  Row,
  Col,
  Form,
  message,
} from "antd";
import CommonSelect from "../../../core/common/commonSelect";
import CommonSelectemp from "../../../core/common/fetchEmpCommon";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useEmpDetails from "../../../core/api/useEmpdetail";
import dayjs from "dayjs";
import useDepartment from "../../../core/api/useDepartment";
import useDesignations from "../../../core/api/useDesignations";
import { useRoles, getRolesList } from "../../../core/api/useRoles";
import useCreateEmployee from "../../../core/api/useCreateEmployee";
import { jobTypeOptions } from "../../../core/hardcoded/jobTypes";
import useDashTable from "../../../core/api/useDashTable";
import { API_BASE_PATH } from "../../../environment";
import { toast } from "react-toastify";
import { useBankInfo } from "../../../core/api/useBankInfo";
import { useFamilyInfo } from "../../../core/api/useFamilyInfo";
import {
  EducationFormData,
  useEducationInfo,
} from "../../../core/api/useEducationInfo";
import { useExperienceInfo } from "../../../core/api/useExperienceInfo";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  updateEmployee,
  updatePersonalInfo,
} from "../../../core/api/mydetPersonal";
import { useAuthToken } from "../../../core/data/redux/useAuthToken";
import { usePermission } from "../../../core/api/useRolePermission";
import useMyDetails from "../../../core/api/usemyDetails";

type PasswordField = "password" | "confirmPassword";

type EmployeeFormType = {
  firstname: string;
  lastName: string;
  employeeId: string;
  joiningDate: string;
  username: string;
  email: string;
  password: string;
  phone: string;
  company: string;
  role: string;
  department: string;
  designation: string;
  jobType: string;
  image: File | null;
  imagePreview: string;
  genType: string;
  gender: string;
  streetAddress: string;
  bloodGroup: string;
  employeeStatus: string;
  country: string;
  state: string;
  city: string;
  zipcode: string;
};
type SelectOption = {
  label: string;
  value: string;
};
type Designation = {
  designation: string;
  department: string;
  totalEmployees?: number;
  status?: string;
  createdAt?: string;
};

type Department = {
  department_name: string;
  employee_count?: number;
  status?: string;
};

type Role = {
  role_name: string;
  status?: string;
};
interface EditPersonalModalProps {
  visible: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const MyDetails = () => {
  const location = useLocation();
  const EmpId = useSelector((state: any) => state.auth.employeeId);
  const empRole = useSelector((state: any) => state.auth.role);
  const empToken = useAuthToken();
  const isEmployeeRole = empRole === "Employee"; // <-- add this
  const isManagerRole = empRole === "Manager";
  const [employeeId, setEmployeeId] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  // ✅ call each hook exactly once per resource
  const myDetailsRead = usePermission("My Details", "read");
  const myDetailsAllowAll = usePermission("My Details", "allow_all");
  const employeesRead = usePermission("Employees", "read");
  const employeesAllowAll = usePermission("Employees", "allow_all");

  // ✅ derive booleans with plain JS (safe)
  const canViewMyDetails = myDetailsRead || myDetailsAllowAll;
  const canViewEmployees = employeesRead || employeesAllowAll;
  const [profileImageUrl, setProfileImageUrl] = useState<string>("");
  const [imageVersion, setImageVersion] = useState(0);

  useEffect(() => {
    setEmployeeId(EmpId);
  }, [EmpId]);

  const { getNormalizedDepartments } = useDepartment(empToken);
  const { fetchDesignationsAllInfo } = useDesignations(empToken);
  const { roles, fetchRoles } = useRoles();

  const {
    data: empDetails,
    isLoading,
    fetchDetails,
    updateAbout,
    updateEmergencyContacts,
  } = useMyDetails(empToken);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  let departmentCache: Department[] | null = null;
  let roleCache: Role[] | null = null;
  let designationCache: Designation[] | null = null;

  const {
    formData,
    handleChangeBank,
    handleSubmitBank,
    handleLocalReset,
    getBankInfo,
  } = useBankInfo(employeeId, empToken); //Bank Information

  const handleSave = () => {
    handleSubmitBank(() => {
      setShowModal(true); // or whatever state closes the modal
    });
  };

  const {
    formDataFamily,
    familyList,
    handleChangeFamily,
    handleSubmitFamily,
    handleDateChangeFamily,
    handleEditFamily,
    handleNewFamilyClick,
    clearForm,
  } = useFamilyInfo(employeeId, empToken); //Family Information
  const {
    formDataEducation,
    setFormDataEducation,
    educationList,
    handleChangeEducation,
    handleDateChangeEducation,
    handleSubmitEducation,
    handleEditEducation,
  } = useEducationInfo(employeeId, empToken); //education Information
  const {
    formDataExperience,
    setFormDataExperience,
    handleResetExperience,
    experienceList,
    handleChangeExperience,
    handleDateChangeExperience,
    handleSubmitExperience,
    handleEditExperience,
  } = useExperienceInfo(employeeId, empToken); //experience info
  const formik = useFormik({
    initialValues: {
      phone: "",
      dob: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .matches(/^[0-9]{10,12}$/, "Phone number must be 10 to 12 digits")
        .required("Required"),
      dob: Yup.string()
        .matches(
          /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-\d{4}$/,
          "Date of birth must be in DD-MM-YYYY format"
        )
        .test("is-valid-date", "Invalid date", (value) => {
          if (!value) return false;
          const [day, month, year] = value.split("-").map(Number);
          const inputDate = new Date(year, month - 1, day);
          const today = new Date();

          return (
            inputDate.getFullYear() === year &&
            inputDate.getMonth() === month - 1 &&
            inputDate.getDate() === day &&
            inputDate <= today
          );
        })
        .required("Date of birth is required"),
    }),
    onSubmit: (values) => {
      // handle save logic here
    },
  });

  useEffect(() => {
    if (employeeId) {
      fetchDetails(employeeId);
    }
  }, [employeeId, fetchDetails]);

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  useEffect(() => {
    const loadDropdowns = async () => {
      try {
        if (!departmentCache) {
          const fetchedDepartments = await getNormalizedDepartments();
          departmentCache = fetchedDepartments;
        }
        if (departmentCache) {
          const departmentOptions = departmentCache.map((item) => ({
            value: item.department_name,
            label: item.department_name,
          }));
          setDepartment([
            { value: "Select", label: "Select" },
            ...departmentOptions,
          ]);
        }

        if (!roleCache) {
          const fetchedRoles = await getRolesList(empToken);
          roleCache = fetchedRoles;
        }
        if (roleCache) {
          const roleOptions = roleCache.map((item: Role) => ({
            value: item.role_name,
            label: item.role_name,
          }));
          setRoleName([{ value: "Select", label: "Select" }, ...roleOptions]);
        }

        if (!designationCache) {
          const fetchedDesignations = await fetchDesignationsAllInfo();
          designationCache = fetchedDesignations;
        }
        if (designationCache) {
          const designationOptions = designationCache.map((item) => ({
            value: item.designation,
            label: item.designation,
          }));
          setDesignation([
            { value: "Select", label: "Select" },
            ...designationOptions,
          ]);
        }
      } catch (error) {
        console.error("Dropdown fetch error:", error);
      }
    };

    loadDropdowns();
  }, []);

  const [roleName, setRoleName] = useState<SelectOption[]>([
    { value: "Select", label: "Select" },
  ]);
  const [department, setDepartment] = useState<SelectOption[]>([
    { value: "Select", label: "Select" },
  ]);
  const {
    data: employees,
    isLoading: isTableLoading,
    refetch,
  } = useDashTable(empToken);

  const { createEmployee, isLoading: isCreating } = useCreateEmployee();

  const [designation, setDesignation] = useState<SelectOption[]>([
    { value: "Select", label: "Select" },
  ]);
  const [jobType, setJobType] = useState(jobTypeOptions);
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setEmployeeForm((prev) => ({
        ...prev,
        image: file,
        imagePreview: URL.createObjectURL(file),
      }));
    }
  };
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  useEffect(() => {
    if (employeeId && empToken) {
      const fetchImage = async () => {
        try {
          const timestamp = Date.now();
          const response = await fetch(
            `${API_BASE_PATH}/register/employee/${employeeId}/image?t=${timestamp}`,
            {
              headers: {
                Authorization: `Bearer ${empToken}`,
              },
            }
          );
          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setProfileImageUrl(url);
          } else {
            setProfileImageUrl("");
          }
        } catch (error) {
          console.error("Error fetching employee image:", error);
          setProfileImageUrl("");
        }
      };
      fetchImage();
    }

    return () => {
      if (profileImageUrl) {
        URL.revokeObjectURL(profileImageUrl);
      }
    };
  }, [employeeId, empToken, imageVersion]);

  useEffect(() => {
    if (isAddModalVisible && empDetails) {
      setEmployeeForm({
        firstname: empDetails.firstname || "",
        lastName: empDetails.lastname || "",
        employeeId: empDetails.employee_id || "",
        joiningDate: empDetails.join_date || "",
        username: empDetails.username || "",
        email: empDetails.email || "",
        password: "", // Always leave password blank for security
        phone: empDetails.phone || "",
        company: empDetails.company || "",
        role: empDetails.role_name || empDetails.role_data?.role_name || "",
        department:
          empDetails.department_name ||
          empDetails.department_data?.department_name ||
          "",
        designation:
          empDetails.designation_name ||
          empDetails.designation_data?.designation_name ||
          "",
        jobType: empDetails.job_type_name || "",
        genType: empDetails.gender || "",
        image: null,
        imagePreview: profileImageUrl || "",
        gender: empDetails.gender || "",
        streetAddress: empDetails.street_address || "",
        bloodGroup: empDetails.blood_group || "",
        employeeStatus: empDetails.employee_status || "",
        country: empDetails.country || "",
        state: empDetails.state_name || "",
        city: empDetails.city_name || "",
        zipcode: empDetails.zip_code || "",
      });
    }
  }, [isAddModalVisible, empDetails, profileImageUrl]);

  const [personalModalVisible, setPersonalModalVisible] = useState(false);
  const [editPersonalForm] = Form.useForm();

  useEffect(() => {
    if (personalModalVisible && empDetails) {
      editPersonalForm.resetFields();
      editPersonalForm.setFieldsValue({
        passportNo: empDetails.passport_no || "",
        passportExpiry: empDetails.passport_exp_date
          ? dayjs(empDetails.passport_exp_date, "YYYY-MM-DD")
          : null,
        dob: empDetails.date_of_birth
          ? dayjs(empDetails.date_of_birth, "YYYY-MM-DD")
          : null,
        aadharNo: empDetails.aadhar_no || "",
        panNo: empDetails.pan_card || "",
        nationality: empDetails.nationality || "",
        religion: empDetails.religion || "",
        maritalStatus: empDetails.marital_status || "",
        employmentSpouse: empDetails.spouse_name || "",
        children: empDetails.number_of_children || "",
      });
    }
  }, [personalModalVisible, empDetails, editPersonalForm]);
  const isEditMode = !!employeeId; // or use a separate `isEdit` state
  const handleSubmit = async () => {
    // Validate required fields before submission
    if (
      !employeeForm.firstname ||
      !employeeForm.email ||
      !employeeForm.username ||
      !employeeForm.employeeId ||
      !employeeForm.joiningDate ||
      !employeeForm.jobType ||
      !employeeForm.role ||
      !employeeForm.department ||
      !employeeForm.designation
    ) {
      toast.warning("Please fill all required fields.");
      return;
    }
    // In add mode, ensure password is provided
    if (!isEditMode && !employeeForm.password) {
      toast.warning("Password is required for new employees.");
      return;
    }
    let formData = new FormData();
    formData.append("firstname", employeeForm.firstname);
    formData.append("lastname", employeeForm.lastName);
    formData.append("employee_id", employeeForm.employeeId);
    formData.append("join_date", employeeForm.joiningDate);
    formData.append("username", employeeForm.username);
    formData.append("email", employeeForm.email);
    if (!isEditMode) {
      formData.append("password", employeeForm.password);
    }
    formData.append("phone", employeeForm.phone);
    formData.append("company", employeeForm.company);
    formData.append("role_name", employeeForm.role);
    formData.append("department_name", employeeForm.department);
    formData.append("designation_name", employeeForm.designation);
    formData.append("job_type_name", employeeForm.jobType);
    formData.append("gender", employeeForm.gender);
    formData.append("street_address", employeeForm.streetAddress);
    formData.append("blood_group", employeeForm.bloodGroup);
    formData.append("employee_status", employeeForm.employeeStatus);
    formData.append("country", employeeForm.country);
    formData.append("state_name", employeeForm.state);
    formData.append("city_name", employeeForm.city);
    formData.append("zip_code", employeeForm.zipcode);
    if (employeeForm.image) {
      formData.append("photo", employeeForm.image);
    }
    try {
      if (isEditMode) {
        await updateEmployee(employeeForm.employeeId, formData, empToken);
        await fetchDetails(employeeId);
        setImageVersion((prev) => prev + 1); // Trigger refetch of image
      } else {
        await createEmployee(formData);

        if (employeeId) {
          fetchDetails(employeeId);
        }
      }
      await refetch();
      setEmployeeForm({
        firstname: "",
        lastName: "",
        employeeId: "",
        joiningDate: "",
        username: "",
        email: "",
        password: "",
        phone: "",
        company: "",
        role: "",
        department: "",
        designation: "",
        jobType: "",
        genType: "",
        image: null,
        imagePreview: "",
        gender: "",
        streetAddress: "",
        bloodGroup: "",
        employeeStatus: "",
        country: "",
        state: "",
        city: "",
        zipcode: "",
      });
      setIsAddModalVisible(false);
      toast.success("Employee information updated successfully!");
    } catch (error: any) {
      // ✅ Handle DATABASE_ERROR specifically - don't show database errors
      if (error?.response?.data?.code === "DATABASE_ERROR") {
        // Skip showing database errors, just show validation message
        toast.warning("Please fill all required fields correctly.");
      } else {
        // For other errors, show the actual error message
        console.error("Error submitting employee data:", error);
        // const message = extractErrorMessage(error);
        // toast.error(message);
      }
    }
  };

  const handlePersonalSubmit = async (values: any) => {
    const payload = {
      date_of_birth: dayjs(values.dob).format("YYYY-MM-DD"),
      aadhar_no: Number(values.aadharNo),
      passport_no: values.passportNo,
      religion: values.religion || "",
      number_of_children: Number(values.children || 0),
      pan_card: values.panNo,
      spouse_name: values.employmentSpouse || "",
      blood_group: "", // Assuming this is not in the form yet
      nationality: values.nationality,
      marital_status: values.maritalStatus,
      passport_exp_date: dayjs(values.passportExpiry).format("YYYY-MM-DD"),
    };

    if (!employeeId) return;

    const success = await updatePersonalInfo(employeeId, payload, empToken);
    if (success) {
      setPersonalModalVisible(false);
      fetchDetails(employeeId); // Refetch employee info
    } else {
      console.error("Failed to update personal info");
    }
  };

  const personalReset = () => {
    editPersonalForm.resetFields();
  };

  const resetForm = personalReset();

  const [employeeForm, setEmployeeForm] = useState<EmployeeFormType>({
    firstname: "",
    lastName: "",
    employeeId: "",
    joiningDate: "",
    username: "",
    email: "",
    password: "",
    phone: "",
    company: "",
    role: "",
    department: "",
    designation: "",
    jobType: "",
    genType: "",
    image: null,
    imagePreview: "",
    gender: "", // newly added
    streetAddress: "", // newly added
    bloodGroup: "",
    employeeStatus: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
  });

  const [editPersonalVisible, setEditPersonalVisible] = useState(false);
  const salaryChoose = [
    { value: "Select", label: "Select" },
    { value: "Monthly", label: "Monthly" },
    { value: "Annualy", label: "Annualy" },
  ];
  const paymenttype = [
    { value: "Select", label: "Select" },
    { value: "Cash", label: "Cash" },
    { value: "Debit Card", label: "Debit Card" },
    { value: "Mobile Payment", label: "Mobile Payment" },
  ];
  const pfcontribution = [
    { value: "Select", label: "Select" },
    { value: "Employee Contribution", label: "Employee Contribution" },
    { value: "Employer Contribution", label: "Employer Contribution" },
    { value: "Provident Fund Interest", label: "Provident Fund Interest" },
  ];
  const additionalrate = [
    { value: "Select", label: "Select" },
    { value: "ESI", label: "ESI" },
    { value: "EPS", label: "EPS" },
    { value: "EPF", label: "EPF" },
  ];
  const esi = [
    { value: "Select", label: "Select" },
    { value: "Employee Contribution", label: "Employee Contribution" },
    { value: "Employer Contribution", label: "Employer Contribution" },
    { value: "Maternity Benefit ", label: "Maternity Benefit " },
  ];

  const handleResetEducation = () => {
    const resetData: EducationFormData = {
      id: undefined,
      employee_id: employeeId ?? "",
      institution_name: "",
      course: "",
      start_date: "",
      end_date: "",
    };

    setFormDataEducation(resetData);
  };
  const [aboutText, setAboutText] = useState(empDetails?.about || "");

  const handleSaveAbout = async () => {
    if (empDetails) {
      await updateAbout(empDetails.employee_id, aboutText, empToken);
      fetchDetails(empDetails.employee_id); // Refresh updated data
    }
  };

  const [contact1, setContact1] = useState("");
  const [contact2, setContact2] = useState("");

  useEffect(() => {
    if (empDetails) {
      setContact1(empDetails.emergency_contact_1 || "");
      setContact2(empDetails.emergency_contact_2 || "");
    }
  }, [empDetails]);

  const handleSaveContacts = async () => {
    if (!contact1 || isNaN(Number(contact1))) {
      alert("Please enter a valid phone number for Contact 1");
      return;
    }

    if (empDetails) {
      await updateEmergencyContacts(
        empDetails.employee_id,
        empToken,
        contact1,
        contact2,
        empDetails
      );
      fetchDetails(empDetails.employee_id); // Refresh updated data
    }
  };

  // Fix for Experience Modal Reset: Listen for modal show event and reset if no ID (add mode)
  useEffect(() => {
    const handleModalShow = () => {
      if (!formDataExperience.id) {
        handleResetExperience(); // Reset only if no ID (new entry)
      }
    };

    const modalElement = document.getElementById("edit_experience");
    if (modalElement) {
      modalElement.addEventListener("show.bs.modal", handleModalShow);
      return () =>
        modalElement.removeEventListener("show.bs.modal", handleModalShow);
    }
  }, [handleResetExperience]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h3 className="d-inline-flex align-items-center mb-3 mb-sm-0">
                My Details
              </h3>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="#"
                  // data-bs-toggle="modal"
                  // data-inert={true}
                  // data-bs-target="#add_bank_satutory"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Bank &amp; Statutory
                </Link>
              </div>
              <div className="ms-3">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-4 theiaStickySidebar">
              <div className="card card-bg-1">
                <div className="card-body p-0">
                  <span className="avatar avatar-xl avatar-rounded border border-2 border-white m-auto d-flex mb-2">
                    <img
                      src={profileImageUrl || "/assets/img/defaultavatar.png"}
                      className="w-auto h-auto"
                      alt="/assets/img/defaultavatar.png"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.onerror = null;
                        target.src = "/assets/img/defaultavatar.png";
                      }}
                    />
                  </span>
                  <div className="text-center px-3 pb-3 border-bottom">
                    <div className="mb-3">
                      <h5 className="d-flex align-items-center justify-content-center mb-1">
                        {[empDetails?.firstname, empDetails?.lastname]
                          .filter(Boolean)
                          .join(" ")}
                        <i className="ti ti-discount-check-filled text-success ms-1" />
                      </h5>
                      <span className="badge badge-soft-dark fw-medium me-2">
                        <i className="ti ti-point-filled me-1" />
                        {empDetails?.designation_name}
                      </span>
                      <span className="badge badge-soft-secondary fw-medium">
                        {empDetails?.employee_status || ""}
                      </span>
                    </div>
                    <div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-id me-2" />
                          Employee ID
                        </span>
                        <p className="text-dark">{empDetails?.employee_id}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-star me-2" />
                          Department
                        </span>
                        <p className="text-dark">
                          {empDetails?.department_name}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-tie me-2" />
                          Role
                        </span>
                        <p className="text-dark">{empDetails?.role_name}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="ti ti-calendar-check me-2" />
                          Date Of Join
                        </span>
                        <p className="text-dark"> {empDetails?.join_date}</p>
                      </div>
                      <div className="row gx-2 mt-3">
                        <div className="col-12">
                          <div>
                            <Link
                              to="#"
                              className="btn btn-dark w-100"
                              data-inert={true}
                              onClick={() => setIsAddModalVisible(true)}
                            >
                              <i className="ti ti-edit me-1" />
                              Edit Info
                            </Link>
                          </div>
                        </div>
                        {/* <div className="col-6">
                          <div>
                            <Link
                              to={all_routes.chat}
                              className="btn btn-primary w-100"
                            >
                              <i className="ti ti-message-heart me-1" />
                              Message
                            </Link>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Basic information</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-phone me-2" />
                        Phone
                      </span>
                      <p className="text-dark"> {empDetails?.phone || "-"}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-mail-check me-2" />
                        Email
                      </span>
                      <Link
                        to="#"
                        className="text-info d-inline-flex align-items-center"
                        style={{
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={empDetails?.email || "-"} // Show full email on hover
                      >
                        {empDetails?.email || "-"}
                        <i className="ti ti-copy text-dark ms-2" />
                      </Link>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-gender-male me-2" />
                        Gender
                      </span>
                      <p className="text-dark text-end">
                        {" "}
                        {empDetails?.gender || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-droplet me-2" />
                        Blood Group
                      </span>
                      <p className="text-dark text-end">
                        {" "}
                        {empDetails?.blood_group || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-cake me-2" />
                        Birdthday
                      </span>
                      <p className="text-dark text-end">
                        {" "}
                        {empDetails?.date_of_birth || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2" />
                        Address
                      </span>
                      <p className="text-dark text-end">
                        {[
                          empDetails?.street_address,
                          empDetails?.area,
                          empDetails?.city_name,
                          empDetails?.country,
                          empDetails?.zip_code,
                        ]
                          .filter(Boolean)
                          .join(" ") || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Personal Information</h6>
                      <Button
                        className="btn btn-sm btn-icon"
                        onClick={() => setPersonalModalVisible(true)}
                      >
                        <i className="ti ti-edit" />
                      </Button>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-e-passport me-2" />
                        Passport No
                      </span>
                      <p className="text-dark">
                        {empDetails?.passport_no || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-calendar-x me-2" />
                        Passport Exp Date
                      </span>
                      <p className="text-dark text-end">
                        {empDetails?.passport_exp_date || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-id me-2" />
                        Aadhar No
                      </span>
                      <p className="text-dark">
                        {empDetails?.aadhar_no || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-credit-card me-2" />
                        PAN No
                      </span>
                      <p className="text-dark text-end">
                        {empDetails?.pan_card || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-gender-male me-2" />
                        Nationality
                      </span>
                      <p className="text-dark text-end">
                        {empDetails?.nationality || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-bookmark-plus me-2" />
                        Religion
                      </span>
                      <p className="text-dark text-end">
                        {empDetails?.religion || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-hotel-service me-2" />
                        Marital status
                      </span>
                      <p className="text-dark text-end">
                        {empDetails?.marital_status || "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-baby-bottle me-2" />
                        No. of children
                      </span>
                      <p className="text-dark text-end">
                        {" "}
                        {empDetails?.number_of_children || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6>Emergency Contact Number</h6>
                <Link
                  to="#"
                  className="btn btn-icon btn-sm"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#edit_emergency"
                >
                  <i className="ti ti-edit" />
                </Link>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <span className="d-inline-flex align-items-center">
                          Primary
                        </span>
                        <h6 className="d-flex align-items-center fw-medium mt-1">
                          {empDetails?.emergency_contact_1}
                          <span className="d-inline-flex mx-1">
                            <i className="ti ti-point-filled text-danger" />
                          </span>
                        </h6>
                      </div>
                      <p className="text-dark">{"Contact 1"}</p>
                    </div>
                  </div>
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <span className="d-inline-flex align-items-center">
                          Secondary
                        </span>
                        <h6 className="d-flex align-items-center fw-medium mt-1">
                          {empDetails?.emergency_contact_2}
                          <span className="d-inline-flex mx-1">
                            <i className="ti ti-point-filled text-danger" />
                          </span>
                        </h6>
                      </div>
                      <p className="text-dark">{"Contact 2"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div>
                <div className="tab-content custom-accordion-items">
                  <div
                    className="tab-pane active show"
                    id="bottom-justified-tab1"
                    role="tabpanel"
                  >
                    <div
                      className="accordion accordions-items-seperate"
                      id="accordionExample"
                    >
                      {/*About Employee*/}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingOne">
                          <div className="accordion-button">
                            <div className="d-flex align-items-center flex-fill">
                              <h5>About Employee</h5>
                              <Link
                                to="#"
                                className="btn btn-sm btn-icon ms-auto"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_employee_about"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setAboutText(empDetails?.about || "");
                                }}
                              >
                                <i className="ti ti-edit" />
                              </Link>

                              {/* <Link
                                to="#"
                                className="d-flex align-items-center collapsed collapse-arrow"
                                data-bs-toggle="collapse"
                                data-bs-target="#primaryBorderOne"
                                aria-expanded="false"
                                aria-controls="primaryBorderOne"
                              >
                                <i className="ti ti-chevron-down fs-18" />
                              </Link> */}
                            </div>
                          </div>
                        </div>
                        <div
                          id="primaryBorderOne"
                          className="accordion-collapse show border-top"
                          aria-labelledby="headingOne"
                        >
                          <div className="accordion-body mt-2">
                            <p className="text-dark text-start">
                              {empDetails?.about || "No information available"}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Bank Information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingTwo">
                          <div className="accordion-button">
                            <div className="d-flex align-items-center flex-fill">
                              <h5>Bank Information</h5>
                              <Link
                                to="#"
                                className="btn btn-sm btn-icon ms-auto"
                                data-bs-toggle="modal"
                                data-inert={true}
                                data-bs-target="#edit_bank"
                              >
                                <i className="ti ti-edit" />
                              </Link>
                              {/* <Link
                                to="#"
                                className="d-flex align-items-center collapsed collapse-arrow"
                                data-bs-toggle="collapse"
                                data-bs-target="#primaryBorderTwo"
                                aria-expanded="false"
                                aria-controls="primaryBorderTwo"
                              >
                                <i className="ti ti-chevron-down fs-18" />
                              </Link> */}
                            </div>
                          </div>
                        </div>
                        <div
                          id="primaryBorderTwo"
                          className="accordion-collapse show border-top"
                          aria-labelledby="headingTwo"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-md-3">
                                <span>Bank Name</span>
                                <h6>{formData.bank_account_name || "-"}</h6>
                              </div>
                              <div className="col-md-3">
                                <span>Bank Account No</span>
                                <h6>{formData.bank_account_no || "-"}</h6>
                              </div>
                              <div className="col-md-3">
                                <span>IFSC Code</span>
                                <h6>{formData.IFSC || "-"}</h6>
                              </div>
                              <div className="col-md-3">
                                <span>Branch</span>
                                <h6>{formData.branch_name || "-"}</h6>
                              </div>
                              <div className="col-md-3">
                                <span>MICR Code</span>
                                <h6>{formData.MICR || "-"}</h6>
                              </div>
                              <div className="col-md-3">
                                <span>Branch Address</span>
                                <h6>{formData.branch_address || "-"}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Family information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingThree">
                          <div className="accordion-button">
                            <div className="d-flex align-items-center justify-content-between flex-fill">
                              <h5>Family Information</h5>
                              <div className="d-flex">
                                <Link
                                  to="#"
                                  className="btn btn-icon btn-sm"
                                  data-bs-toggle="modal"
                                  data-bs-target="#edit_familyinformation"
                                  onClick={handleNewFamilyClick} // <-- clears form before opening modal
                                >
                                  <i className="ti ti-edit" />
                                </Link>
                                {/* <Link
                                  to="#"
                                  className="d-flex align-items-center collapsed collapse-arrow"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#primaryBorderThree"
                                  aria-expanded="false"
                                  aria-controls="primaryBorderThree"
                                >
                                  <i className="ti ti-chevron-down fs-18" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          id="primaryBorderThree"
                          className="accordion-collapse show border-top"
                          aria-labelledby="headingThree"
                        >
                          <div className="accordion-body">
                            {familyList.length === 0 ? (
                              <p>No family information available.</p>
                            ) : (
                              familyList.map((family, index) => (
                                <div className="row mb-3" key={index}>
                                  <div className="col-md-3">
                                    <span className="d-inline-flex align-items-center">
                                      Name
                                    </span>
                                    <h6 className="d-flex align-items-center fw-medium mt-1">
                                      {family.name}
                                    </h6>
                                  </div>
                                  <div className="col-md-3">
                                    <span className="d-inline-flex align-items-center">
                                      Relationship
                                    </span>
                                    <h6 className="d-flex align-items-center fw-medium mt-1">
                                      {family.relationship_type}
                                    </h6>
                                  </div>
                                  <div className="col-md-3">
                                    <span className="d-inline-flex align-items-center">
                                      Date of birth
                                    </span>
                                    <h6 className="d-flex align-items-center fw-medium mt-1">
                                      {family.dob}
                                    </h6>
                                  </div>
                                  <div className="col-md-2">
                                    <span className="d-inline-flex align-items-center">
                                      Phone
                                    </span>

                                    <h6 className="d-flex align-items-center fw-medium mt-1">
                                      {family.phone}
                                    </h6>
                                  </div>
                                  <div className="col-md-1 d-flex align-items-center justify-content-end">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-icon"
                                      data-bs-toggle="modal"
                                      data-bs-target="#edit_familyinformation"
                                      onClick={() => handleEditFamily(family)}
                                      title="Edit"
                                    >
                                      <i className="ti ti-pencil" />
                                    </button>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* Education Details */}
                        <div className="col-md-6">
                          <div className="accordion-item">
                            <div className="row">
                              <div
                                className="accordion-header"
                                id="headingFour"
                              >
                                <div className="accordion-button">
                                  <div className="d-flex align-items-center justify-content-between flex-fill">
                                    <h6 className="fw-bold text-dark mb-0">
                                      Education Details
                                    </h6>
                                    <div className="d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className="btn btn-icon btn-sm"
                                        data-bs-toggle="modal"
                                        data-bs-target="#edit_education"
                                        onClick={() =>
                                          setFormDataEducation({
                                            institution_name: "",
                                            course: "",
                                            start_date: "",
                                            end_date: "",
                                          })
                                        }
                                      >
                                        <i className="ti ti-edit" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="primaryBorderFour"
                                className="accordion-collapse show border-top" // <-- show keeps it always open
                                aria-labelledby="headingFour"
                              >
                                <div className="accordion-body">
                                  <div>
                                    {educationList.map((edu) => (
                                      <div className="mb-3" key={edu.id}>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <div>
                                            <span className="text-muted text-capitalize">
                                              {edu.institution_name}
                                            </span>
                                            <h6 className="fw-bold text-capitalize mt-1">
                                              {edu.course}
                                            </h6>
                                          </div>
                                          <div className="d-flex align-items-center gap-2">
                                            <p className="mb-0 text-dark">
                                              {dayjs(edu.start_date).format(
                                                "YYYY"
                                              )}{" "}
                                              -{" "}
                                              {dayjs(edu.end_date).format(
                                                "YYYY"
                                              )}
                                            </p>
                                            <Link
                                              to="#"
                                              className="btn btn-sm btn-icon"
                                              data-bs-toggle="modal"
                                              data-bs-target="#edit_education"
                                              onClick={() =>
                                                handleEditEducation(edu)
                                              }
                                            >
                                              <i className="ti ti-edit" />
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Experience */}
                        <div className="col-md-6">
                          <div className="accordion-item">
                            <div className="row">
                              <div
                                className="accordion-header"
                                id="headingFive"
                              >
                                <div className="accordion-button">
                                  <div className="d-flex align-items-center justify-content-between flex-fill">
                                    <h5>Experience</h5>
                                    <div className="d-flex">
                                      <Link
                                        to="#"
                                        className="btn btn-icon btn-sm"
                                        data-bs-toggle="modal"
                                        data-bs-target="#edit_experience"
                                        onClick={handleResetExperience} // force reset when opening add modal
                                      >
                                        <i className="ti ti-edit" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                id="primaryBorderFive"
                                className="accordion-collapse show border-top" // <-- always open
                                aria-labelledby="headingFive"
                              >
                                <div className="accordion-body">
                                  <div>
                                    {experienceList?.map((item) => (
                                      <div className="mb-3" key={item.id}>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <div>
                                            <h6 className="d-inline-flex align-items-center fw-medium">
                                              {item.previous_company_name}
                                            </h6>
                                            <span className="d-flex align-items-center badge bg-secondary-transparent mt-1">
                                              <i className="ti ti-point-filled me-1" />
                                              {item.designation}
                                            </span>
                                          </div>
                                          <p className="text-dark mb-0">
                                            {item.start_date} -{" "}
                                            {item.working_present
                                              ? "Present"
                                              : item.end_date}
                                          </p>
                                          <button
                                            className="btn btn-sm btn-light ms-2"
                                            data-bs-toggle="modal"
                                            data-bs-target="#edit_experience"
                                            onClick={() =>
                                              handleEditExperience(item)
                                            }
                                          >
                                            <i className="ti ti-edit" />
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025 © IATT.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              IATT
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Edit Employee - Bootstrap Modal */}
      <div
        className={`modal fade ${isAddModalVisible ? "show d-block" : ""}`}
        tabIndex={-1}
        role="dialog"
        aria-hidden={!isAddModalVisible}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Employee</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setIsAddModalVisible(false)}
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                  {/* Image Upload with Preview */}
                  <div className="col-md-12">
                    <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                        {employeeForm.imagePreview ? (
                          <img
                            src={
                              employeeForm.imagePreview.startsWith("blob:")
                                ? employeeForm.imagePreview
                                : profileImageUrl ||
                                  "/assets/img/defaultavatar.png"
                            }
                            alt="/assets/img/defaultavatar.png"
                            className="img-fluid rounded-circle"
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.onerror = null;
                              target.src = "/assets/img/defaultavatar.png";
                            }}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              overflow: "hidden",
                              borderRadius: "50%",
                              display: "block",
                            }}
                          />
                        ) : (
                          <i className="ti ti-photo text-gray-2 fs-16" />
                        )}
                      </div>
                      <div className="profile-upload">
                        <div className="mb-2">
                          <h6 className="mb-1">Upload Profile Image</h6>
                          <p className="fs-12">Image should be below 4 mb</p>
                        </div>
                        <div className="profile-uploader d-flex align-items-center">
                          <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                            Upload
                            <input
                              type="file"
                              className="form-control image-sign"
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            onClick={() =>
                              setEmployeeForm((prev) => ({
                                ...prev,
                                image: null,
                                imagePreview: "",
                              }))
                            }
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Controlled Inputs */}
                  {[
                    { label: "First Name", required: true, name: "firstname" },
                    { label: "Last Name", required: false, name: "lastName" },
                    {
                      label: "Employee ID",
                      required: true,
                      name: "employeeId",
                      disabled: isEditMode,
                    },
                    { label: "Username", required: true, name: "username" },
                    {
                      label: "Email",
                      required: true,
                      name: "email",
                      type: "email",
                    },
                    {
                      label: "Phone Number",
                      required: true,
                      name: "phone",
                      validate: true,
                    },
                    { label: "Company", required: true, name: "company" },
                  ].map((field, index) => (
                    <div className="col-md-6" key={index}>
                      <div className="mb-3">
                        <label className="form-label">
                          {field.label}
                          {field.required && (
                            <span className="text-danger"> *</span>
                          )}
                        </label>
                        <input
                          type={field.type || "text"}
                          className="form-control"
                          value={(employeeForm as any)[field.name] ?? ""}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (field.name === "phone") {
                              const numericOnly = value.replace(/\D/g, "");
                              if (numericOnly.length <= 12) {
                                setEmployeeForm((prev) => ({
                                  ...prev,
                                  phone: numericOnly,
                                }));
                              }
                            } else {
                              setEmployeeForm((prev) => ({
                                ...prev,
                                [field.name]: e.target.value,
                              }));
                            }
                          }}
                          disabled={field.disabled || false}
                        />
                        {field.name === "phone" &&
                          employeeForm.phone.length > 0 &&
                          !/^\d{10,12}$/.test(employeeForm.phone) && (
                            <small className="text-danger">
                              Phone number must be 10–12 digits, numbers only.
                            </small>
                          )}
                      </div>
                    </div>
                  ))}

                  {/* Joining Date */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Joining Date <span className="text-danger">*</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format="YYYY-MM-DD"
                          value={
                            employeeForm.joiningDate
                              ? dayjs(employeeForm.joiningDate, "YYYY-MM-DD")
                              : null
                          }
                          onChange={(date) =>
                            setEmployeeForm((prev) => ({
                              ...prev,
                              joiningDate: date
                                ? dayjs(date).format("YYYY-MM-DD")
                                : "",
                            }))
                          }
                          placeholder="YYYY-MM-DD"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Select Dropdowns */}
                  {[
                    {
                      label: "Role",
                      options: roleName,
                      required: true,
                      field: "role",
                    },
                    {
                      label: "Department",
                      options: department,
                      required: true,
                      field: "department",
                    },
                    {
                      label: "Designation",
                      options: designation,
                      required: true,
                      field: "designation",
                    },
                    {
                      label: "Job Type",
                      required: true,
                      options: jobType,
                      field: "jobType",
                    },
                  ]
                    .filter(() => !(isManagerRole || isEmployeeRole))
                    .map((item, i) => (
                      <div className="col-md-6" key={i}>
                        <div className="mb-3">
                          <label className="form-label">
                            {item.label} <span className="text-danger"> *</span>
                          </label>
                          <CommonSelectemp
                            className="select"
                            options={item.options}
                            value={
                              item.options.find(
                                (opt) =>
                                  opt.value ===
                                  (employeeForm[
                                    item.field as keyof EmployeeFormType
                                  ] ?? "")
                              ) || { value: "", label: "Select" }
                            }
                            onChange={(selected) =>
                              setEmployeeForm((prev) => ({
                                ...prev,
                                [item.field]: selected?.value || "",
                              }))
                            }
                          />
                        </div>
                      </div>
                    ))}

                  {/* Gender */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Gender</label>
                      <select
                        className="form-select"
                        value={employeeForm.gender ?? ""}
                        onChange={(e) =>
                          setEmployeeForm((prev) => ({
                            ...prev,
                            gender: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>

                  {/* Blood Group */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Blood Group</label>
                      <select
                        className="form-select"
                        value={employeeForm.bloodGroup ?? ""}
                        onChange={(e) =>
                          setEmployeeForm((prev) => ({
                            ...prev,
                            bloodGroup: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select</option>
                        <option value="A+">A+</option>
                        <option value="A-">A-</option>
                        <option value="B+">B+</option>
                        <option value="B-">B-</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                        <option value="O+">O+</option>
                        <option value="O-">O-</option>
                      </select>
                    </div>
                  </div>

                  {/* Address Fields */}
                  {[
                    { label: "Street Address", name: "streetAddress" },
                    // { label: "Employee Status", name: "employeeStatus" },
                    { label: "Country", name: "country" },
                    { label: "State", name: "state" },
                    { label: "City", name: "city" },
                    { label: "Zip Code", name: "zipcode" },
                  ].map((field, index) => (
                    <div className="col-md-6" key={index}>
                      <div className="mb-3">
                        <label className="form-label">{field.label}</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            typeof employeeForm[
                              field.name as keyof EmployeeFormType
                            ] === "string"
                              ? (employeeForm[
                                  field.name as keyof EmployeeFormType
                                ] as string)
                              : ""
                          }
                          onChange={(e) =>
                            setEmployeeForm((prev) => ({
                              ...prev,
                              [field.name]: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  ))}

                  {/* Footer */}
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      onClick={() => setIsAddModalVisible(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={async () => {
                        await handleSubmit();
                        setIsAddModalVisible(false);
                      }}
                      disabled={isCreating}
                    >
                      {isCreating ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* ✅ Modal backdrop for blur/dim effect */}
      {isAddModalVisible && (
        <div
          className="modal-backdrop fade show"
          style={{ backdropFilter: "blur(3px)" }} // <-- adds blur effect
        />
      )}

      {/* Edit Personal */}
      <Modal
        title="Edit Personal Info"
        open={personalModalVisible}
        onCancel={() => setPersonalModalVisible(false)}
        footer={null}
        width={800}
        centered
        destroyOnClose
        maskClosable
      >
        <Form
          layout="vertical"
          form={editPersonalForm}
          onFinish={handlePersonalSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Passport No"
                name="passportNo"
                rules={[{ required: true, message: "Passport No is required" }]}
              >
                <Input placeholder="Enter passport number" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Passport Expiry Date"
                name="passportExpiry"
                rules={[{ required: true, message: "Expiry date is required" }]}
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  style={{ width: "100%" }}
                  placeholder="Select date"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Date of Birth"
                name="dob"
                rules={[
                  { required: true, message: "Date of birth is required" },
                ]}
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  style={{ width: "100%" }}
                  placeholder="Select date"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Aadhar Number"
                name="aadharNo"
                rules={[
                  { required: true, message: "Aadhar number is required" },
                ]}
              >
                <Input placeholder="Enter Aadhar number" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="PAN Number"
                name="panNo"
                rules={[{ required: true, message: "PAN number is required" }]}
              >
                <Input placeholder="Enter PAN number" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Nationality"
                name="nationality"
                rules={[{ required: true, message: "Nationality is required" }]}
              >
                <Input placeholder="Enter nationality" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Religion" name="religion">
                <Input placeholder="Enter religion" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Marital Status"
                name="maritalStatus"
                rules={[
                  { required: true, message: "Marital status is required" },
                ]}
              >
                <Select placeholder="Select marital status">
                  <Select.Option value="single">Single</Select.Option>
                  <Select.Option value="married">Married</Select.Option>
                  <Select.Option value="divorced">Divorced</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Employment of Spouse" name="employmentSpouse">
                <Input placeholder="Enter spouse's employment status" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="No. of Children" name="children">
                <Input type="number" placeholder="Enter number of children" />
              </Form.Item>
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-4">
            <Button onClick={personalReset} className="me-2">
              Reset
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              style={{ backgroundColor: "#fa8c16", borderColor: "#fa8c16" }}
            >
              Save
            </Button>
          </div>
        </Form>
      </Modal>

      {/* /Edit Personal */}
      {/* Edit Emergency Contact */}
      <div className="modal fade" id="edit_emergency">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Emergency Contact Details</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form>
              <div className="modal-body pb-0">
                <div className="border-bottom mb-3">
                  <div className="row">
                    <h5 className="mb-3">Primary Contact</h5>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={"Emergency Contact"}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Relationship</label>
                        <input
                          type="text"
                          className="form-control"
                          value="Friend or Family Member"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Phone No 1 <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={contact1}
                          onChange={(e) => setContact1(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Phone No 2</label>
                        <input
                          type="number"
                          className="form-control"
                          value={contact2}
                          onChange={(e) => setContact2(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-white me-2"
                  onClick={() => {
                    setContact1("");
                    setContact2("");
                  }}
                >
                  Reset
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSaveContacts}
                  data-bs-dismiss="modal"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Emergency Contact */}
      {/* Edit Bank */}
      <div className="modal fade" id="edit_bank">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Bank Details</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Bank Details <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="bank_account_name"
                        value={formData.bank_account_name}
                        onChange={handleChangeBank}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Bank account No <span className="text-danger"> *</span>{" "}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="bank_account_no"
                        value={formData.bank_account_no}
                        onChange={handleChangeBank}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        IFSC Code <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="IFSC"
                        value={formData.IFSC}
                        onChange={handleChangeBank}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        MICR <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="MICR"
                        value={formData.MICR}
                        onChange={handleChangeBank}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Branch Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="branch_name"
                        value={formData.branch_name}
                        onChange={handleChangeBank}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Branch Address <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="branch_address"
                        value={formData.branch_address}
                        onChange={handleChangeBank}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  onClick={handleLocalReset}
                >
                  Reset
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Add / Edit Family Info Modal */}
      <div className="modal fade" id="edit_familyinformation">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Family Information</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                await handleSubmitFamily();
              }}
            >
              <div className="modal-body pb-0">
                <div className="row">
                  {/* Name */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formDataFamily.name}
                        onChange={handleChangeFamily}
                        required
                      />
                    </div>
                  </div>

                  {/* Relationship */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Relationship <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="relationship_type"
                        value={formDataFamily.relationship_type}
                        onChange={handleChangeFamily}
                        required
                      />
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        name="phone"
                        value={formDataFamily.phone}
                        onChange={handleChangeFamily}
                      />
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Date of Birth <span className="text-danger">*</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{ format: "DD-MM-YYYY", type: "mask" }}
                          getPopupContainer={() =>
                            document.getElementById("edit_familyinformation") ||
                            document.body
                          }
                          placeholder="DD-MM-YYYY"
                          value={
                            formDataFamily.dob
                              ? dayjs(formDataFamily.dob, "YYYY-MM-DD")
                              : null
                          }
                          onChange={(date) => handleDateChangeFamily(date)}
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  onClick={clearForm}
                >
                  Reset
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Add / Edit Education */}
      <div className="modal fade" id="edit_education">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Education Information</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {/* Institution Name */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Institution Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="institution_name"
                        value={formDataEducation.institution_name}
                        onChange={handleChangeEducation}
                      />
                    </div>
                  </div>

                  {/* Course */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Course <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="course"
                        value={formDataEducation.course}
                        onChange={handleChangeEducation}
                      />
                    </div>
                  </div>

                  {/* Start Date */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Start Date <span className="text-danger">*</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{ format: "DD-MM-YYYY", type: "mask" }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          value={
                            formDataEducation.start_date
                              ? dayjs(formDataEducation.start_date)
                              : null
                          }
                          onChange={(date) =>
                            handleDateChangeEducation("start_date", date)
                          }
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* End Date */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        End Date <span className="text-danger">*</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{ format: "DD-MM-YYYY", type: "mask" }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          value={
                            formDataEducation.end_date
                              ? dayjs(formDataEducation.end_date)
                              : null
                          }
                          onChange={(date) =>
                            handleDateChangeEducation("end_date", date)
                          }
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  onClick={handleResetEducation}
                >
                  Reset
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={handleSubmitEducation}
                >
                  {formDataEducation.id ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Education */}
      {/* Add Experience */}
      <div className="modal fade" id="edit_experience">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Company Information</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Previous Company Name{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="previous_company_name"
                        className="form-control"
                        value={formDataExperience.previous_company_name}
                        onChange={handleChangeExperience}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Designation <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="designation"
                        className="form-control"
                        value={formDataExperience.designation}
                        onChange={handleChangeExperience}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Start Date <span className="text-danger"> *</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{
                            format: "DD-MM-YYYY",
                            type: "mask",
                          }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          value={
                            formDataExperience.start_date
                              ? dayjs(formDataExperience.start_date)
                              : null
                          }
                          onChange={(date) =>
                            handleDateChangeExperience("start_date", date)
                          }
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        End Date <span className="text-danger"> *</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{
                            format: "DD-MM-YYYY",
                            type: "mask",
                          }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          value={
                            formDataExperience.end_date
                              ? dayjs(formDataExperience.end_date)
                              : null
                          }
                          onChange={(date) =>
                            handleDateChangeExperience("end_date", date)
                          }
                          disabled={formDataExperience.working_present}
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-check-label d-flex align-items-center mt-0">
                        <input
                          className="form-check-input mt-0 me-2"
                          type="checkbox"
                          checked={formDataExperience.working_present}
                          onChange={(e) =>
                            setFormDataExperience((prev) => ({
                              ...prev,
                              working_present: e.target.checked,
                              end_date: e.target.checked ? "" : prev.end_date,
                            }))
                          }
                        />
                        <span className="text-dark">
                          Check if you are working presently
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  onClick={handleResetExperience}
                >
                  Reset
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={handleSubmitExperience}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Experience */}
      {/* Add Employee Success */}
      <div className="modal fade" id="success_modal" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center p-3">
                <span className="avatar avatar-lg avatar-rounded bg-success mb-3">
                  <i className="ti ti-check fs-24" />
                </span>
                <h5 className="mb-2">Employee Added Successfully</h5>
                <p className="mb-3">
                  Stephan Peralt has been added with Client ID :{" "}
                  <span className="text-primary">#EMP - 0001</span>
                </p>
                <div>
                  <div className="row g-2">
                    <div className="col-6">
                      <Link
                        to={all_routes.employeeList}
                        className="btn btn-dark w-100"
                      >
                        Back to List
                      </Link>
                    </div>
                    <div className="col-6">
                      <Link
                        to={all_routes.employeedetails}
                        className="btn btn-primary w-100"
                      >
                        Detail Page
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Client Success */}
      {/* Add Statuorty */}
      <div className="modal fade" id="add_bank_satutory">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Bank &amp; Statutory</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="border-bottom mb-4">
                  <h5 className="mb-3">Basic Salary Information</h5>
                  <div className="row mb-2">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Salary basis <span className="text-danger"> *</span>
                        </label>
                        <CommonSelect
                          className="select"
                          options={salaryChoose}
                          defaultValue={salaryChoose[0]}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Salary basis</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue="$"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Payment type</label>
                        <CommonSelect
                          className="select"
                          options={paymenttype}
                          defaultValue={paymenttype[0]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-bottom mb-4">
                  <h5 className="mb-3">PF Information</h5>
                  <div className="row mb-2">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">
                          PF contribution{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <CommonSelect
                          className="select"
                          options={pfcontribution}
                          defaultValue={pfcontribution[0]}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">PF No</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Employee PF rate</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Additional rate</label>
                        <CommonSelect
                          className="select"
                          options={additionalrate}
                          defaultValue={additionalrate[0]}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Total rate</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                </div>
                <h5 className="mb-3">ESI Information</h5>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        ESI contribution<span className="text-danger"> *</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={esi}
                        defaultValue={esi[0]}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">ESI Number</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Employee ESI rate<span className="text-danger"> *</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Additional rate</label>
                      <CommonSelect
                        className="select"
                        options={additionalrate}
                        defaultValue={additionalrate[0]}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Total rate</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Statuorty */}
      {/* Correct About Employee Modal */}
      <div className="modal fade" id="edit_employee_about" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit About Employee</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <textarea
                className="form-control"
                rows={5}
                value={aboutText}
                onChange={(e) => setAboutText(e.target.value)}
                placeholder="Write something about the employee..."
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-white me-2"
                onClick={() => setAboutText("")}
              >
                Reset
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveAbout}
                data-bs-dismiss="modal"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* About */}
    </>
  );
};
export default MyDetails;
